import { CircularProgress } from "@material-ui/core";
import React from "react";

export const CenteredCircularProgress = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <CircularProgress />
    </div>
  );
};
